import React from 'react';
import { Helmet } from 'react-helmet-async';
import { langPathSuffix } from '../lang-utils';

const SITE_URL = 'https://www.geltonastraliukas.lt';
const OG_LOCALE = { lt: 'lt_LT', en: 'en_US', ru: 'ru_RU' };
const HOME_LABEL = { lt: 'Pradžia', en: 'Home', ru: 'Главная' };

function buildBreadcrumb({ path, lang, pageName, parentPage }) {
  if (!pageName || path === '/') return null;
  const home = `${SITE_URL}/`;
  const current = `${SITE_URL}${path}${langPathSuffix(lang)}`;

  const items = [
    { '@type': 'ListItem', position: 1, name: HOME_LABEL[lang] || HOME_LABEL.lt, item: home }
  ];

  if (parentPage) {
    items.push({
      '@type': 'ListItem',
      position: 2,
      name: parentPage.name,
      item: `${SITE_URL}${parentPage.path}`
    });
    items.push({ '@type': 'ListItem', position: 3, name: pageName, item: current });
  } else {
    items.push({ '@type': 'ListItem', position: 2, name: pageName, item: current });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items
  };
}

function Seo({ path = '/', lang = 'lt', title, description, image, pageName, parentPage }) {
  const canonical = `${SITE_URL}${path}${langPathSuffix(lang)}`;
  const ogImage = image || `${SITE_URL}/gallery/image-1.jpg`;
  const breadcrumb = buildBreadcrumb({ path, lang, pageName, parentPage });

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <link rel="alternate" hrefLang="lt"        href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="en"        href={`${SITE_URL}${path}en/`} />
      <link rel="alternate" hrefLang="ru"        href={`${SITE_URL}${path}ru/`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path}`} />

      <meta property="og:title"       content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type"        content="website" />
      <meta property="og:url"         content={canonical} />
      <meta property="og:image"       content={ogImage} />
      <meta property="og:locale"      content={OG_LOCALE[lang] || OG_LOCALE.lt} />
      <meta property="og:site_name"   content="Geltonas Traliukas" />

      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={ogImage} />

      {breadcrumb && (
        <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      )}
    </Helmet>
  );
}

export default Seo;
